var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-item"},[_c('div',{staticClass:"trigger",attrs:{"data-state":_vm.state,"disabled":_vm.disabled}},[(_vm.isCompleted)?_c('NbIcon',{attrs:{"icon":"check","size":16}}):_c('NbIcon',{attrs:{"icon":"circle","size":_vm.state === 'active' ? 16 : 10}})],1),_vm._t("default",null,{"state":_vm.state})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }